<template>
    <div class="change-button">
        <span @click="handlerTrue()" :class="[on ? 'on' : '']">EN</span>
        <span @click="handlerFalse()" :class="[on ? '' : 'on']">中文</span>
    </div>
</template>
<style>
.change-button{
    position: absolute;
    width: 100px;
    height: 30px;
    background: #fff;
    border-radius: 2em;
    right: 9%;
    bottom: 5%;
    z-index: 10;
}
.change-button span{
    color: #000;
    font-size: 16px;
    display: inline-block;
    width: 50%;
    height: 30px;
    line-height: 30px;
    overflow: hidden;
    cursor: pointer;
}
.change-button .on{
    border-radius: 2em;
    background:  #eee;
    border: 1px solid #ccc;
}
</style>
<script>
    export default{
        data(){
            return{
                on:false
            }
        },
        methods:{
            handlerTrue(){
                this.on = true
                this.$emit('change','english')
            },
            handlerFalse(){
                this.on = false
                this.$emit('change','chinese')
            }
        }
    }
</script>
